import { TextInput, TextInputProps } from "../elements/TextInput";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = TextInputProps & FormItemProps<string>;

export const FormTextInput = (props: Props) => {
  return (
    <FormItemContainer<string> {...props}>
      <TextInput {...props} />
    </FormItemContainer>
  );
};
